// @flow

export const reportCategory = [
  { id: 1, name: '計算書類承認の件', is_extra: false },
  { id: 2, name: '取締役選任の件', is_extra: false },
  { id: 3, name: '取締役解任の件', is_extra: false },
  { id: 4, name: '監査役選任の件', is_extra: false },
  { id: 5, name: '監査役解任の件', is_extra: false },
  { id: 6, name: '役員報酬改定の件', is_extra: false },
  { id: 7, name: '株式の分割', is_extra: false },
  { id: 8, name: '定款一部変更の件', is_extra: true },
  { id: 9, name: '募集株式変更の件', is_extra: true },
  { id: 10, name: '募集新株予約券発行の件', is_extra: true },
  { id: 11, name: 'その他', is_extra: false },
  { id: 12, name: 'その他', is_extra: true },
];

export const REPORT_OTHER_CATEGORY = [2];
